import { z } from 'zod';

export const SignatureCertificationDataSchema = z.object({
  idContractObjectType: z.number().nullable(),
  idContactObjectSubtype: z.number().nullable(),
  textcontactObjectSubtype: z.string().nullable(),
  idCountryTextLanguage: z.number(),
  idCountryUseOfText: z.number(),
  notes: z.string(),
});

export type ISignatureCertificationRelationshipData = z.infer<
  typeof SignatureCertificationDataSchema
>;

export function getEmptySignatureCertificationRelationshipData() {
  return {
    idContractObjectType: null,
    idContactObjectSubtype: null,
    idCountryTextLanguage: 1,
    idCountryUseOfText: 1,
    textcontactObjectSubtype: null,
    notes: '',
  } as ISignatureCertificationRelationshipData;
}
